import React, { useState } from 'react';
import { TextField, Button, CircularProgress } from '@mui/material';
import gradeScaleApi from '../../apis/gradeScale';
import { GradeScale } from '../../types/gradeScaleType';
import { AddGradeScaleProps } from './types/GradeScaleType';
import { SnackbarSeverityType } from '../../enums';
import DialogModal from '../../components/DialogModal';

const AddGradeScaleDialog: React.FC<AddGradeScaleProps> = ({
  open,
  onClose,
  onSaved,
  school,
  showToast
}) => {
  const [gradeScaleName, setGradeScaleName] = useState('');
  const [saving, setSaving] = useState(false);

  const handleCancel = () => {
    setGradeScaleName('');
    onClose();
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const newScale: GradeScale = {
        school,
        name: gradeScaleName,
        gradeScaling: {}
      };
      const saved = await gradeScaleApi.saveGradeScales(school, newScale);

      onSaved(saved);
      onClose();
      setGradeScaleName('');
      showToast(
        'Grade scale added successfully!',
        SnackbarSeverityType.success
      );
    } catch (error) {
      console.error('Error saving grade scale:', error);
      showToast('Failed to add grade scale.', SnackbarSeverityType.error);
    } finally {
      setSaving(false);
    }
  };

  const isSaveDisabled = !gradeScaleName || saving;

  return (
    <DialogModal
      open={open}
      onClose={handleCancel}
      title='Add Grade Scale'
      actions={
        <>
          <Button onClick={handleCancel} color='primary'>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            disabled={isSaveDisabled}
            variant='contained'
          >
            {saving ? <CircularProgress size={24} color='inherit' /> : 'Save'}
          </Button>
        </>
      }
    >
      <TextField
        margin='dense'
        label='Grade Scale Name'
        fullWidth
        value={gradeScaleName}
        onChange={(e) => setGradeScaleName(e.target.value)}
        required
      />
    </DialogModal>
  );
};

export default AddGradeScaleDialog;
